import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../../../../shared/my-constants';

@Injectable()
export class CpoeInvestigationService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private AddRecord = webapi + 'temr_visit_investigation/create';
    private GetRecordByVisitId = webapi + 'temr_visit_investigation/list?';
    private GetRecordByTimelineId = webapi + 'temr_visit_investigation/listbytimelienid?';
    private GetRecordByVisitIdfordocorder = webapi + 'temr_visit_investigation/docorderlist?';
    private GetRecordByVisitIdForOPD = webapi + 'temr_visit_investigation/listForOpd?';
    private GetIPDRecordByAdmission = webapi + 'temr_visit_investigation/listbyadmission?';
    private GetunbilledIPDRecordByAdmission = webapi + 'temr_visit_investigation/listbyadmissionIPDunbilled?';
    private DeleteServiceById = webapi + 'temr_visit_investigation/delete/';
    private UpdateServiceForBill = webapi + 'temr_visit_investigation/updatedoctororder';
    private GetAllRecordByTimelineList = webapi + 'temr_visit_investigation/getAllRecordByTimelineList';
    private AddSericefromepisode = webapi + 'temr_visit_investigation/addservice';
    private AddOneRecord = webapi + 'temr_visit_investigation/create_single_service';
    private GetRecordIPDForLabOrRadiologyListBytmeLineId = webapi + 'temr_visit_investigation/getRecordIPDForLabOrRadiologyListBytmeLineId/';
    private GetRecordListbyEMRTimelienId = webapi + 'temr_visit_investigation/listbyEMRtimelienid/';
    private Alllistbytimelienid = webapi + 'temr_visit_investigation/alllistbytimelienid?';
    private ListRecordByStartEndDate = webapi + 'temr_visit_investigation/ListRecordByStartEndDate?';

    constructor(
        private http: Http
    ) {
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updateServiceForBill(model: any) {
        return this.http.post(this.UpdateServiceForBill, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(respponse => respponse.json())
            .catch(this.handleError);
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetRecordByVisitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getnotbilledAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetRecordByVisitIdfordocorder + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordByTimelineId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetRecordByTimelineId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordServiceForOPD(currentPage: any, size: any, patientRegSrc: any, viVisitId: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetRecordByVisitIdForOPD + 'page=' + currentPage + '&size=' + size + '&patientRegSrc=' + patientRegSrc + '&viVisitId=' + viVisitId + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllServiceRecord(patientId: any, admissionDate: any, patientRegSrc: any) {
        return this.http.get(this.GetIPDRecordByAdmission + 'patientId=' + patientId + '&admissionDate=' + admissionDate + '&patientRegSrc=' + patientRegSrc)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getnotbilledIPDRecordService(patientId: any, admissionDate: any, patientRegSrc: any) {
        return this.http.get(this.GetunbilledIPDRecordByAdmission + 'patientId=' + patientId + '&admissionDate=' + admissionDate + '&patientRegSrc=' + patientRegSrc)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteServiceById + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordByTimelineList(model: any) {
        return this.http.post(this.GetAllRecordByTimelineList, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addSericefromepisode(model: any) {
        return this.http.post(this.AddSericefromepisode, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addOneRecord(model: any) {
        return this.http.post(this.AddOneRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordIPDForLabOrRadiologyListBytmeLineId(timelineId: any) {
        return this.http.get(this.GetRecordIPDForLabOrRadiologyListBytmeLineId + timelineId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordListbyEMRTimelienId(timelineId: any) {
        return this.http.get(this.GetRecordListbyEMRTimelienId + timelineId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    alllistbytimelienid(timelineId: any) {
        return this.http.get(this.Alllistbytimelienid + 'qString=' + timelineId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAlDoctorsAdvice(currentPage: any, size: any, startdate: any, enddate: any, sort: any, col: any, unitid: any, qString: any): Promise<any> {
        // console.log(this.ListRecordByStartEndDate + 'page=' + currentPage + '&size=' + size + '&startdate=' + startdate + '&enddate=' + enddate + '&sort=' + sort + '&col=' + col + '&unitid=' + unitid);
        return this.http.get(this.ListRecordByStartEndDate + 'page=' + currentPage + '&size=' + size + '&startdate=' + startdate + '&enddate=' + enddate + '&sort=' + sort + '&col=' + col + '&unitid=' + unitid + '&qString=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-investigation/cpoe-investigation.service.ts